import React from 'react';
import ReactDOM from 'react-dom';
import 'react-hot-loader/patch';
import { AppContainer } from 'react-hot-loader';
import { library } from '@fortawesome/fontawesome-svg-core';
import loginViewFontIcons from './font-awesome/iconsLibrary';
import RootComponent from './RootComponent';

library.add(...loginViewFontIcons);

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
     document.getElementById('container')
  );
};

render(RootComponent);

if (module.hot) {
  module.hot.accept('./RootComponent.jsx', () => {
    const NewRootComponent = require('./RootComponent.jsx').default; // eslint-disable-line global-require, import/extensions
    render(NewRootComponent);
  });
}
